<!-- 洗美项目的编辑查看 -->
<template>
  <div class="drawer">
    <el-drawer
      size="800px"
      title="预约详情"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <el-scrollbar class="bor" style="height: 100%">
        <div class="page">
          <div style="padding: 10px; background: #f5f5f5">预约客户</div>
          <div style="padding: 10px">
            <el-row>
              <el-col :span="6"
                ><div>
                  预约类型:{{ reserveType == "1" ? "洗美" : "" }}
                </div></el-col
              >
              <el-col :span="6"
                ><div>提交时间:{{ operationTime }}</div></el-col
              >
              <el-col :span="6"
                ><div>客户姓名:{{ userName }}</div></el-col
              >
              <el-col :span="6"
                ><div>客户电话:{{ linkmanMobile }}</div></el-col
              >
            </el-row>
          </div>
          <div style="padding: 10px; background: #f5f5f5">预约信息</div>
          <div style="padding: 10px">
            <el-row>
              <el-col :span="6"
                ><div>预约日期:{{ reserveDate }}</div></el-col
              >
              <el-col :span="6"
                ><div>洗美人员:{{ bathingInfo.staffName }}</div></el-col
              >

              <el-col :span="6"
                ><div>所需时间:{{ bathingInfo.sumDuration }}分钟</div></el-col
              >
              <el-col :span="6"
                ><div>预约备注:{{ remark }}</div></el-col
              >
            </el-row>
          </div>
          <div style="padding: 10px; background: #f5f5f5">预约宠物</div>
          <div style="padding: 10px">
            <el-row>
              <el-col :span="6"
                ><div>宠物名字:{{ memberPetList[0].petName }}</div></el-col
              >
              <el-col :span="6"
                ><div>
                  宠物种类:{{ bathingInfo.reservePetInfo.petType.name }}
                </div></el-col
              >
              <el-col :span="6"
                ><div>
                  宠物品种:{{ bathingInfo.reservePetInfo.petClass.name }}
                </div></el-col
              >
              <el-col :span="6"
                ><div>
                  宠物体重:{{ bathingInfo.reservePetInfo.petWeight }}
                </div></el-col
              >
            </el-row>
          </div>

          <div style="padding: 10px; background: #f5f5f5">预约项目</div>
          <div style="padding: 15px">
            <el-row :gutter="30">
              <el-col
                :span="6"
                v-for="item in reserveProjectList"
                :key="item.id"
                ><div class="project">{{ item.projectName }}</div></el-col
              >
            </el-row>
          </div>

          <!-- 回访 -->
          <div v-if="state !== 1">
            <div style="padding: 10px; background: #f5f5f5">回访确定</div>
            <div style="padding: 10px">
              <el-row style="margin-bottom: 16px">
                <el-col :span="6"
                  ><div>
                    回访人员:{{ updateOperationInfo.userName }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    回访时间:{{ updateOperationInfo.operationTime }}
                  </div></el-col
                >
              </el-row>
              <el-row>
                <el-col :span="6"
                  ><div>
                    确定备注:{{
                      confirmInfo.confirmRemark
                        ? confirmInfo.confirmRemark
                        : "无"
                    }}
                  </div></el-col
                >
              </el-row>
            </div>
          </div>
          <!-- 已到店 -->
          <div v-if="state == 3">
            <div style="padding: 15px; background: #f5f5f5">预约结果</div>
            <div style="padding: 15px">
              <el-row style="margin-bottom: 16px">
                <el-col :span="6"><div>预约状态:已到店</div></el-col>
                <el-col :span="6"
                  ><div>
                    操作人员:{{ updateOperationInfo.userName }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    操作时间:{{ updateOperationInfo.operationTime }}
                  </div></el-col
                >
              </el-row>
              <el-row>
                <el-col :span="6"
                  ><div>到店时间:{{ arrivalInfo.operationTime }}</div></el-col
                >
                <el-col :span="6"
                  ><div>
                    到店备注:{{
                      arrivalInfo.arrivalReamrk
                        ? arrivalInfo.arrivalReamrk
                        : "无"
                    }}
                  </div></el-col
                >
              </el-row>
            </div>
          </div>
          <!-- 取消预约 -->
          <div v-if="state == -2">
            <div style="padding: 15px; background: #f5f5f5">预约结果</div>
            <div style="padding: 15px">
              <el-row style="margin-bottom: 16px">
                <el-col :span="6"><div>预约状态:已取消</div></el-col>
                <el-col :span="6"
                  ><div>
                    操作人员:{{ updateOperationInfo.userName }}
                  </div></el-col
                >
                <el-col :span="6"
                  ><div>
                    操作时间:{{ updateOperationInfo.operationTime }}
                  </div></el-col
                >
              </el-row>
              <el-row>
                <el-col :span="6"
                  ><div>取消原因:{{ cancelInfo.cancelCause }}</div></el-col
                >
                <el-col :span="6"
                  ><div>取消备注:{{ cancelInfo.cancelRemark }}</div></el-col
                >
                <el-col :span="6"
                  ><div>取消时间:{{ cancelInfo.operationTime }}</div></el-col
                >
              </el-row>
            </div>
          </div>

          <!--回访结束  -->
          <div v-if="state == 1">
            <div style="padding: 15px; background: #f5f5f5">确认预约信息</div>
            <div style="padding: 10px 15px">
              <el-row style="margin-bottom: 16px">
                修改预约:
                <el-radio v-model="updateBath" label="2">否</el-radio>
                <el-radio v-model="updateBath" label="1">是</el-radio>
              </el-row>
              <div v-if="updateBath == '1'">
                <el-row style="margin-bottom: 16px">
                  洗美日期:
                  <el-select
                    v-model="createBath.reserveDate"
                    @change="changeBathDate"
                    placeholder="请选择"
                    style="width: 180px"
                  >
                    <el-option
                      v-for="item in days"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-row>
                <el-row style="margin-bottom: 16px">
                  洗美人员:
                  <el-select
                    v-model="createBath.staffId"
                    placeholder="请选择"
                    @change="changeBathStaff"
                  >
                    <el-option
                      v-for="item in staffList"
                      :key="item.id"
                      :label="item.staffName"
                      :value="item.staffId"
                    >
                    </el-option>
                  </el-select>
                </el-row>
                <el-row style="margin-bottom: 16px">
                  洗美时间:
                  <el-select
                    v-model="createBath.times"
                    multiple
                    @visible-change="changeTime($event)"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in timeUseList"
                      :key="item.id"
                      :disabled="item.canState !== 1"
                      :label="
                        parseInt(item.time) == item.time
                          ? item.time + ':00'
                          : parseInt(item.time) + ':30'
                      "
                      :value="item.time"
                    >
                    </el-option>
                  </el-select>
                </el-row>
                <el-row style="margin-bottom: 16px; display: inline">
                  <div style="display: flex">
                    洗美项目:
                    <div>
                      <div class="projext">洗澡</div>
                      <div>
                        <el-select
                        clearable
                          @blur="changeConfig"
                          :disabled="configStateXz"
                          @change="changeConfig"
                          class="inputP"
                          v-model="createBath.xzProjectId"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in xzProjects"
                            :key="item.id"
                            :label="item.projectName"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>

                    <div>
                      <div class="projext">美容</div>
                      <div>
                        <el-select
                        clearable
                          class="inputP"
                          :disabled="configState"
                          @change="changeConfig"
                          @blur="changeConfig"
                          v-model="createBath.mrProjectId"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in mrProjects"
                            :key="item.id"
                            :label="item.projectName"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div>
                      <div class="projext">单项服务</div>
                      <div>
                        <el-select
                        style="width:400px"
                          clearable
                          multiple
                          class="inputP"
                          v-model="createBath.dxProjectId"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in dxProjects"
                            :key="item.id"
                            :label="item.projectName"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                </el-row>
                <el-row style="margin-bottom: 16px">
                  确认备注:
                  <el-input
                    type="textarea"
                    v-model="changeRemark"
                    style="width: 150px"
                  ></el-input>
                </el-row>
              </div>
              <div v-else>
                <el-row style="margin-bottom: 300px">
                  确认备注:
                  <el-input
                    type="textarea"
                    v-model="confirmRemark"
                    style="width: 150px"
                  ></el-input>
                </el-row>
              </div>
            </div>
          </div>
          <!-- 到店 -->
          <div v-if="state == 2">
            <div style="padding: 15px; background: #f5f5f5">确认预约结果</div>
            <div style="padding: 10px 15px">
              <el-row style="margin-bottom: 16px">
                预约情况:
                <el-radio v-model="arrival" label="2">已到店</el-radio>
                <!-- <el-radio v-model="arrival" label="1">取消</el-radio> -->
              </el-row>
              <div v-if="arrival == '2'">
                <el-row style="margin-bottom: 16px">
                  到店时间:
                  <el-date-picker
                    v-model="arrivalTime"
                    type="datetime"
                    value-format="yyyy-MM-dd H:mm:ss"
                  >
                  </el-date-picker>
                </el-row>

                <el-row style="margin-bottom: 300px">
                  到店备注:
                  <el-input
                    type="textarea"
                    v-model="arrivalReamrk"
                    style="width: 150px"
                  ></el-input>
                </el-row>
              </div>
              <!-- 取消 -->
              <div v-else>
                <el-row style="margin-bottom: 16px">
                  取消原因:
                  <el-select v-model="cancelCause" placeholder="请选择">
                    <el-option
                      v-for="item in cancelCauseList"
                      :key="item._id"
                      :label="item.item_name"
                      :value="item.item_name"
                    >
                    </el-option>
                  </el-select>
                </el-row>
                <el-row style="margin-bottom:150px">
                  取消备注:
                  <el-input
                    type="textarea"
                    v-model="cancelRemark"
                    style="width: 150px"
                  ></el-input>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div style="height: 150px"></div>
      <div class="btnBox" v-if="state == 1">
        <div class="btnItem" @click="drawerStatus = false">取消</div>
        <div class="btnItem submit" @click="submit">保存</div>
      </div>
      <div class="btnBox" v-if="state == 2">
        <div class="btnItem" @click="drawerStatus = false">取消</div>
        <div class="btnItem submit" @click="submit2" v-if="arrival == 1">
          提交
        </div>
        <div class="btnItem submit" v-if="arrival == 2" @click="submit3">
          提交并跳转洗美
        </div>
      </div>
    </el-drawer>
  </div>
</template>
  
  <script>
export default {
  props: {
    id: {
      default: "",
    },
    arrivalState: {
      default: "",
    },
  },
  data() {
    return {
      configStateXz: false,
      configState: false,
      memberPetList: [
        {
          petName: "",
          petClassName: "",
        },
      ],
      cancelInfo: {
        cancelCause: "",
        cancelRemark: "",
        operationTime: "",
      },
      // 已到店
      arrivalInfo: {
        arrivalReamrk: "",
        operationTime: "",
      },
      reserveType: "",
      arrivalTime: this.$moment().format("YYYY-MM-DD H:mm:ss"),
      arrivalReamrk: "",
      cancelCauseList: [],
      cancelCause: "",
      cancelRemark: "", //未到到店取消备注
      arrival: "2",
      // 洗美预约
      createBath: {
        times: [],
        reserveDate: "",
        staffId: "", //员工id
        time: "",
        xzProjectId: "",
        mrProjectId: "",
        dxProjectId: [],
      },
      staffList: [],
      staffListChange: [],
      projects: [], //洗美项目集合
      confirmRemark: "",
      dxProjects: [],
      mrProjects: [],
      xzProjects: [],
      changeRemark: "",
      updateBath: "2",
      days: [], //时间列表
      drawerStatus: false,
      staffNum: "",
      timeUseList: [],
      times: [], //洗美时间
      userId: "",
      userName: "",
      linkmanMobile: "",
      operationTime: "", //创建时间
      state: "",
      reserveDate: "",
      remark: "",
      reserveProjectList: [],
      // 回访人员
      updateOperationInfo: {
        operationTime: "",
        userId: "",
        userName: "",
      },
      confirmInfo: {
        confirmRemark: "",
      },
      //洗美信息
      bathingInfo: {
        staffName: "",
        staffPosition: "",
        sumDuration: "",
        // 预约宠物信息
        reservePetInfo: {
          petId: "",
          petWeight: "",
          petType: {
            name: "",
          },
          petClass: {
            name: "",
          },
          petHairType: {
            name: "",
          },
        },
      },
    };
  },
  mounted() {
    if (this.id) {
      this.getReserveRecord();
    }
    if (this.arrivalState) {
      this.arrival = this.arrivalState;
    } else {
      this.arrival = "2";
    }
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getDataList();
      this.getDataBase();
    });
  },
  methods: {
    // 洗澡美容
    changeConfig() {
      console.log("失去焦点");
      if (this.createBath.xzProjectId) {
        this.configState = true;
      } else {
        this.configState = false;
      }
      if (this.createBath.mrProjectId) {
        this.configStateXz = true;
      } else {
        this.configStateXz = false;
      }
      //
    },
    // 到店
    submit3() {
      let params = {
        id: this.id,
        arrivalInfo: {
          operationTime: this.arrivalTime,
          userId: this.userId,
          userName: this.userName,
          confirmRemark: this.arrivalReamrk,
        },
      };
      // console.log("params到店确认", params);
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_AppAdmin + "/api/Resvere/Arrival", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$store.commit("set_yuyueUserId", this.userId);
            this.$store.commit(
              "set_yuyuePetId",
              this.bathingInfo.reservePetInfo.petId
            );
            this.$store.state.ximei.type = "add";
            console.log("预约用户", this.$store.state.yuyueUserId);
            console.log("预约宠物id", this.$store.state.yuyuePetId);
            console.log("res确定到店", res);
            // this.drawerStatus = false;
            this.$emit("submit");

            // 路由跳转
            this.$router.push({
              path: "/mendian/shouyin",
            });
            // 选中工作台
            this.$store.commit("setCurNavIndex_mendian", {
              title: "工作台",
              path: "/mendian/shouyin",
            });
          }
        });
    },
    // 未到店
    submit2() {
      // 取消
      if (this.$public.isNull(this.cancelCause)) {
        this.$message({
          message: "请选择取消原因",
          type: "error",
        });
        return;
      }
      // if (this.$public.isNull(this.cancelRemark)) {
      //   this.$message({
      //     message: "请输入取消备注",
      //     type: "error",
      //   });
      //   return;
      // }
      let params = {
        id: this.id,
        cancelInfo: {
          operationTime: this.$moment().format("YYYY-MM-DD H:mm:ss"),
          userId: this.userId,
          userName: this.userName,
          cancelCause: this.cancelCause,
          cancelRemark: this.cancelRemark,
        },
      };
      console.log("取消params", params);
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_AppAdmin + "/api/Resvere/Cancel", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            //   console.log("res取消到店", res);
            // this.drawerStatus = false;
            this.$emit("submit");
          }
        });
    },
    submit() {
      // 洗美确定
      if (this.updateBath == "2") {
        // console.log("不修改");
        let params = {
          id: this.id,
          confirmInfo: {
            operationTime: this.$moment().format("YYYY-MM-DD H:mm:ss"),
            userId: this.userId,
            userName: this.userName,
            confirmRemark: this.confirmRemark,
          },
        };
        // console.log("params", params);
        let loading = this.$loading();
        this.$http
          .post(process.env.VUE_APP_AppAdmin + "/api/Resvere/Confirm", params)
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              //   console.log("res洗美确认到店", res);
              // this.drawerStatus = false;
              this.$emit("submit");
            }
          });
      } else {
        console.log("修改");
        if (this.$public.isNull(this.createBath.reserveDate)) {
          this.$message({
            message: "请输入选择预约日期",
            type: "error",
          });
          return;
        }
        if (this.$public.isNull(this.createBath.staffId)) {
          this.$message({
            message: "请选择洗美人员",
            type: "error",
          });
          return;
        }
        if (this.$public.isNull(this.createBath.times)) {
          this.$message({
            message: "请选择洗美时间",
            type: "error",
          });
          return;
        }
        this.createBath.time = this.createBath.times[0];
        if (this.createBath.time % 1 == 0) {
          this.createBath.time = this.createBath.time + ":00";
        } else {
          this.createBath.time = parseInt(this.createBath.time) + ":30";
        }
        this.projects = [];
        console.log("this洗澡111", this.projects);
        if (this.createBath.xzProjectId) {
          let xzNum = this.xzProjects.findIndex(
            (a) => a.id == this.createBath.xzProjectId
          );
          if (xzNum > -1) {
            let obj = {
              projectType: this.xzProjects[xzNum].projectType,
              projectId: this.createBath.xzProjectId,
              projectName: this.xzProjects[xzNum].projectName,
              coverImg: this.xzProjects[xzNum].coverImg,
              duration: this.createBath.times.length * 30,
            };
            this.projects.push(obj);
            console.log("this洗澡", this.projects);
          }
        }
        if (this.createBath.mrProjectId) {
          let mrNum = this.mrProjects.findIndex(
            (a) => a.id == this.createBath.mrProjectId
          );
          if (mrNum > -1) {
            let obj = {
              projectType: this.mrProjects[mrNum].projectType,
              projectId: this.createBath.mrProjectId,
              projectName: this.mrProjects[mrNum].projectName,
              coverImg: this.mrProjects[mrNum].coverImg,
              duration: this.createBath.times.length * 30,
            };
            this.projects.push(obj);
            console.log("this美容", this.projects);
          }
          // console.log("mrNum", mrNum);
        }
        if (this.createBath.dxProjectId.length) {
          this.createBath.dxProjectId.forEach((a) => {
            let dxNum = this.dxProjects.findIndex((b) => b.id == a);
            if (dxNum > -1) {
              let obj = {
                projectId: a,
                projectType: this.dxProjects[dxNum].projectType,
                projectName: this.dxProjects[dxNum].projectName,
                coverImg: this.dxProjects[dxNum].coverImg,
                duration: 0,
              };
              this.projects.push(obj);
            }
          });
          console.log("this单项", this.projects);
        }
        console.log("this单项", this.projects);
        let params = {
          id: this.id,
          staffId: this.createBath.staffId,
          staffName: this.staffList[this.staffNum].staffName,
          staffPosition: this.staffList[this.staffNum].staffPosition,
          reserveDate: this.createBath.reserveDate + " " + this.createBath.time,
          times: this.createBath.times,
          projects: this.projects,
        };
        console.log("params洗美", params);
        let loading = this.$loading();
        this.$http
          .post(
            process.env.VUE_APP_AppAdmin + "/api/Resvere/UpdateBathing",
            params
          )
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              // console.log("res洗美修改", res);
              // this.drawerStatus = false;
              this.$emit("submit");
            }
          });
      }
    },
    //   关闭弹框
    handleClose() {
      this.$emit("submit");
    },
    changeBathDate() {
      this.createBath.staffId = "";
      this.createBath.times = [];
      if (this.createBath.reserveDate) {
        this.getResvereTimeByDay();
      }
    },
    // 获取字典配置
    getDataBase() {
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_zichan +
            "/api/SystemConfig/GetSystemDictionByCode",
          { code: "quxiaoyuyue" }
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log("字典信息", res);
            this.cancelCauseList = res.data.item_list || [];
          }
        });
    },
    // 判断时间只能连续选择
    changeTime(callback) {
      // console.log("callback", callback);
      if (callback == false && this.createBath.times.length > 0) {
        console.log("this.createBath.times111", this.createBath.times);
        var arr = [];
        arr = this.createBath.times.map((a) => {
          return a * 10;
        });
        arr.sort((a, b) => {
          return a - b;
        });
        for (var i = 0; i < arr.length - 1; i++) {
          let num = arr[i + 1] - arr[i];
          if (num > 5) {
            this.$message.error("请选择连续的时间段");
            this.createBath.times = [];
            return;
          }
        }
      }
    },
    // 获取空闲员工时间表
    async getResvereTimeByDay() {
      let params = {
        day: this.createBath.reserveDate,
        shopId: this.$store.state.shopId,
        id: this.id,
      };
      await this.$http
        .get(
          process.env.VUE_APP_AppAdmin +
            "/api/Resvere/GetResvereTimeByDayUpdate",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            this.staffList = res.data;
            // console.log("res 员工1232", this.staffList);
          }
        });
    },
    // 选择洗美人员显示时间
    changeBathStaff() {
      this.createBath.times = [];
      if (this.createBath.staffId) {
        let index = this.staffList.findIndex(
          (v) => v.staffId == this.createBath.staffId
        );
        this.staffNum = index;
        if (index !== -1) {
          this.timeUseList = this.staffList[index].timeUseList;
        }
      }
    },

    // 获取详情
    getReserveRecord() {
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_AppAdmin + "/api/Resvere/GetReserveRecord", {
          id: this.id,
        })
        .then(async (res) => {
          loading.close();
          if (res.code == 0) {
            // console.log("洗美预约详情", res);
            this.memberPetList = res.data.memberPetList;
            this.reserveDate = res.data.reserveDate;
            this.createBath.reserveDate = this.reserveDate.split(" ")[0];

            this.createBath.staffId = res.data.bathingInfo.staffId;
            //changeBathStaff
            if (this.createBath.reserveDate) {
              await this.getResvereTimeByDay();
              this.changeBathStaff();
            }
            this.createBath.times = res.data.bathingInfo.times;
            if (this.createBath.staffId) {
              // console.log(this.createBath.staffId);
              // console.log("staffList", this.staffList);
              let index = this.staffList.findIndex(
                (v) => v.staffId == this.createBath.staffId
              );
              if (index > 0) {
                this.timeUseList = this.staffList[index].timeUseList;
              }
              // console.log("timeUseList", this.timeUseList);
            }
            this.state = res.data.state;
            this.userId = res.data.userId;
            this.reserveType = res.data.reserveType;
            this.userName = res.data.linkmanName;
            this.updateOperationInfo =
              res.data.updateOperationInfo || this.updateOperationInfo;
            this.confirmInfo = res.data.confirmInfo || this.confirmInfo;
            this.linkmanMobile = res.data.linkmanMobile;
            this.operationTime = res.data.createOperationInfo.operationTime;
            this.bathingInfo = res.data.bathingInfo || this.bathingInfo;
            this.remark = res.data.remark;
            this.reserveProjectList = res.data.bathingInfo.reserveProjectList;
            if (this.reserveProjectList.length) {
              const arr = [];
              this.reserveProjectList.forEach((item) => {
                if (item.projectType.id == "1") {
                  this.createBath.xzProjectId = item.projectId;
                } else if (item.projectType.id == "2") {
                  this.createBath.mrProjectId = item.projectId;
                } else if (item.projectType.id == "3") {
                  arr.push(item.projectId);
                }
              });
              this.createBath.dxProjectId = arr;
            }
            if (this.state == -2) {
              this.cancelInfo = res.data.cancelInfo;
            }
            // arrivalInfo到店
            if (this.state == 3) {
              this.arrivalInfo = res.data.arrivalInfo;
            }
            this.getXZConfigList();
            this.getMRConfigList();
            this.getDXConfigList();
            if (this.createBath.xzProjectId) {
              this.configState = true;
            } else {
              this.configState = false;
            }
            if (this.createBath.mrProjectId) {
              this.configStateXz = true;
            } else {
              this.configStateXz = false;
            }
          }
        });
    },
    // 获取洗美
    // 获取洗美// projectType 1 洗澡 2美容 3 单项服务
    getXZConfigList() {
      let params = {
        projectType: 1,
        petType: this.bathingInfo.reservePetInfo.petType.id,
        pageIndex: 1,
        pageSize: 20,
        keyWord: "",
        shopId: this.$store.state.shopId,
        state: 1, // 0全部 1 启用 2禁用
      };
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/GetConfigList",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.xzProjects = res.data.list;
          }
        });
    },
    // 获取美容
    getMRConfigList() {
      let params = {
        projectType: 2,
        petType: this.bathingInfo.reservePetInfo.petType.id,
        pageIndex: 1,
        pageSize: 20,
        keyWord: "",
        shopId: this.$store.state.shopId,
        state: 1, // 0全部 1 启用 2禁用
      };
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/GetConfigList",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.mrProjects = res.data.list;
          }
        });
    },
    // 获取单项
    getDXConfigList() {
      let params = {
        projectType: 3,
        petType: this.bathingInfo.reservePetInfo.petType.id,
        pageIndex: 1,
        pageSize: 20,
        keyWord: "",
        shopId: this.$store.state.shopId,
        state: 1, // 0全部 1 启用 2禁用
      };
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/Resvere/GetConfigList",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.dxProjects = res.data.list;
          }
        });
    },
    //返回最近七天的日期
    getDataList() {
      let days = [];
      let data = new Date();
      for (let i = 0; i <= 24 * 6; i += 24) {
        //今天加上后6天
        let dateItem = new Date(data.getTime() + i * 60 * 60 * 1000); //使用当天时间戳加上以前的时间毫秒（小时*分*秒*毫秒）
        let y = dateItem.getFullYear(); //获取年份
        let m = dateItem.getMonth() + 1; //获取月份js月份从0开始，需要+1
        let d = dateItem.getDate(); //获取日期
        m = this.addDate0(m); //给为单数的月份补零
        d = this.addDate0(d); //给为单数的日期补零
        let valueItem = y + "-" + m + "-" + d; //组合
        days.push(valueItem); //添加至数组
      }
      // console.log("最近七天日期：", days);
      this.days = days;
    },

    //给日期加0
    addDate0(time) {
      if (time.toString().length == 1) {
        time = "0" + time.toString();
      }
      return time;
    },
  },
};
</script>
  
  <style scoped lang="scss">
.el-scrollbar__wrap {
  overflow-x: hidden !important;
}
.page {
  font-size: 12px;
  .project {
    padding: 10px 0px;
    background: #fff4eb;
    border-radius: 5px;
    border: 1px solid #f5882a;
    font-size: 12px;
    color: #f5882a;
    text-align: center;
    box-sizing: border-box;
    margin-bottom: 5px;
  }
  .btnBox {
    width: 100%;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    display: flex;
    position: absolute;
    bottom: 0;
    z-index: 10;
    .btnItem {
      text-align: center;
      width: 100%;
      background-color: #d6d6d6;
      cursor: pointer;
      &.submit {
        background-color: $mainColor;
      }
    }
  }
}
.projext {
  margin: 8px;
}
.inputP {
  width: 150px;
  margin-right: 5px;
  margin-bottom: 10px;
}
</style>